// Toast notification system - Alpine.js component

export const toast = () => ({
  // State
  toasts: [],
  
  // Initialize component
  init() {
    console.log('Toast system initialized');
    
    // Listen for global toast events
    window.addEventListener('show-toast', (event) => {
      this.show(event.detail.message, event.detail.type, event.detail.duration);
    });
  },
  
  // Show a toast notification
  show(message, type = 'info', duration = 5000) {
    const id = this.generateId();
    const toast = {
      id,
      message,
      type,
      visible: false
    };
    
    this.toasts.push(toast);
    
    // Trigger show animation
    this.$nextTick(() => {
      const toastElement = this.$refs[`toast-${id}`];
      if (toastElement) {
        toast.visible = true;
      }
    });
    
    // Auto-remove after duration
    if (duration > 0) {
      setTimeout(() => {
        this.remove(id);
      }, duration);
    }
    
    console.log(`Toast shown: ${type} - ${message}`);
    return id;
  },
  
  // Remove a toast by ID
  remove(id) {
    const index = this.toasts.findIndex(t => t.id === id);
    if (index !== -1) {
      // Trigger hide animation
      this.toasts[index].visible = false;
      
      // Remove from array after animation
      setTimeout(() => {
        this.toasts.splice(index, 1);
      }, 300);
    }
  },
  
  // Clear all toasts
  clear() {
    this.toasts.forEach(toast => {
      toast.visible = false;
    });
    
    setTimeout(() => {
      this.toasts = [];
    }, 300);
  },
  
  // Get toast styling class
  getToastClass(type) {
    const baseClass = 'toast';
    const typeClasses = {
      success: 'toast-success',
      error: 'toast-error',
      warning: 'toast-warning',
      info: 'toast-info'
    };
    
    return `${baseClass} ${typeClasses[type] || typeClasses.info}`;
  },
  
  // Get toast icon
  getToastIcon(type) {
    const icons = {
      success: '✅',
      error: '❌',
      warning: '⚠️',
      info: 'ℹ️'
    };
    
    return icons[type] || icons.info;
  },
  
  // Generate unique ID
  generateId() {
    return 'toast_' + Date.now() + '_' + Math.random().toString(36).substring(2);
  }
});

// Global toast helper function
export const showToast = (message, type = 'info', duration = 5000) => {
  window.dispatchEvent(new CustomEvent('show-toast', {
    detail: { message, type, duration }
  }));
};